import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { consentApi } from '../services/api';

export const CookieBanner: React.FC = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true);
    }
  }, []);

  const handleConsent = async (accepted: boolean) => {
    localStorage.setItem('cookie_consent', accepted ? 'accepted' : 'refused');
    setVisible(false);
    if (user) {
      await consentApi.syncCookies(accepted).catch(() => {});
    }
  };

  // Auto-acceptation après 30 secondes sans action
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => handleConsent(true), 30000);
    return () => clearTimeout(timer);
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Nous utilisons des cookies pour améliorer votre expérience.{' '}
        <a href="/cookies-policy">En savoir plus</a>
      </p>
      <div className="cookie-banner-actions">
        <button
          onClick={() => handleConsent(true)}
          className="btn btn-primary btn-sm"
        >
          Accepter
        </button>
        <button
          onClick={() => handleConsent(false)}
          className="btn btn-secondary btn-sm"
        >
          Refuser
        </button>
      </div>
    </div>
  );
};
